export const banners = [
  './assets/banners/Banner-001.webp',
  './assets/banners/Banner-002.webp',
  './assets/banners/Banner-003.webp',
  './assets/banners/Banner-004.webp'
]
